@import (reference) '~ss-ui-client/src/constants/spacing.module.less';

.content {
  padding: @space-0;
}
